module.exports = __webpack_public_path__ + "static/media/howSection3Image1.13ebddd4.gif";